import { Injectable } from '@angular/core';
import { FormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { getDefaultControlValue, RequestModeControlName } from '@gk/gk-modules';
import { ECSControlName } from '../../../../components/electronic-correspondence-statement/models/form/form.model';
import { BaseNewRequestFormService } from '../../../../shared/base-new-request-form/base-new-request-form.service';
import {
  PLNewRequestControlName,
  PLNewRequestFormGroup,
} from './new-request-form.model';

@Injectable({
  providedIn: 'root',
})
export class PLNewRequestFormService {
  constructor(
    private formBuilder: UntypedFormBuilder,
    private baseNewRequestFormService: BaseNewRequestFormService,
  ) {}

  getFormGroup(): FormGroup<PLNewRequestFormGroup> {
    return this.formBuilder.group({
      ...this.baseNewRequestFormService.getCommonInvestorFormGroup(
        {
          [ECSControlName.ElectronicCorrespondenceStatement]: false,
          [RequestModeControlName.RequestMode]: true,
        },
        {
          addressFormGroupBasedOnSelectControls: true,
          disableAddressFormInNaturalPersonGroup: true,
        },
      ).controls,
      [PLNewRequestControlName.Place]: [
        getDefaultControlValue(),
        Validators.required,
      ],
      [PLNewRequestControlName.Street]: [getDefaultControlValue()],
      [PLNewRequestControlName.AreaToLease]: [
        getDefaultControlValue(),
        Validators.required,
      ],
      [PLNewRequestControlName.Comments]: [getDefaultControlValue()],
      [PLNewRequestControlName.LeaseDate]: [
        getDefaultControlValue(),
        Validators.required,
      ],
      [PLNewRequestControlName.Purpose]: [
        getDefaultControlValue(),
        Validators.required,
      ],
      [PLNewRequestControlName.AnexDateFrom]: [
        getDefaultControlValue(),
        Validators.required,
      ],
      [PLNewRequestControlName.AnexDescription]: [
        getDefaultControlValue(),
        Validators.required,
      ],
      [PLNewRequestControlName.LeaseNumber]: [
        getDefaultControlValue(),
        Validators.required,
      ],
    });
  }
}
